<template>
  <div class="private-session">
    <div class="private-session-header">
      <button class="back-btn" @click="handleBack">
        <i class="el-icon-arrow-left"></i>
      </button>
      <div class="session-title">{{ currentSession.name || "未知" }}</div>
    </div>
    <MsgList
      ref="msgList"
      class="msg-list"
      :messages="messages"
      :currentSession="currentSession"
      @load-more-messages="handleLoadMoreMessages"
      :type="activeTab"
      @resendMessage="resendMessage"
    />
    <ChatInput
      ref="chatInput"
      :input="input"
      :readonly="readonly"
      @send="handleSend"
      @input-change="handleInputChange"
      :private-session="true"
      :userInfo="userInfo"
    >
    </ChatInput>
  </div>
</template>
<script>
import MsgList from "../conversation/MsgList.vue";
import ChatInput from "../conversation/ChatInput.vue";
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "Private",
  props: {
    messages: Array,
    input: String,
    readonly: Boolean,
  },
  components: {
    MsgList,
    ChatInput,
  },
  computed: {
    ...mapState("newChat", ["currentSession", "userInfo", "activeTab"]),
    ...mapGetters("newChat", ["currentSessionId"]),
  },
  methods: {
    ...mapActions("newChat", ["switchSession"]),
    resendMessage(message) {
      this.$emit("resendMessage", message);
    },
    handleLoadMoreMessages(params, callback) {
      this.$emit("load-more-messages", params, callback);
    },
    handleSend(data) {
      this.$emit("send", data);
    },
    handleInputChange(value) {
      this.$emit("input-change", value);
    },
    handleBack() {
      this.switchSession({});
      this.$emit("private-back");
    },
  },
};
</script>
<style lang="scss" scoped>
.private-session {
  height: 100%;
  display: flex;
  flex-direction: column;
  .private-session-header {
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0 24px;
    .back-btn {
      position: absolute;
      left: 2px;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
      font-weight: bold;
      font-size: 14px;
      color: #ecedee;
    }
    .session-title {
      font-weight: 500;
      font-size: 12px;
      color: #ecedee;
      line-height: 20px;
    }
  }
  .msg-list {
    flex: 1;
    height: 0;
    overflow: auto;
  }
}
</style>
